export default {"src":"/_next/static/media/sell.d99594f3.svg","height":34,"width":30,"blurWidth":0,"blurHeight":0};